// extracted by mini-css-extract-plugin
export default {"heading":"Redemption_heading__kuy7+","text-orange":"Redemption_text-orange__pvSjM"};